/** Generate by swagger-axios-codegen */
// @ts-nocheck
/* eslint-disable */

/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic, { type AxiosInstance, type AxiosRequestConfig } from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {
  /**
   * show loading status
   */
  loading?: boolean;
  /**
   * display error message
   */
  showError?: boolean;
  /**
   * data security, extended fields are encrypted using the specified algorithm
   */
  security?: Record<string, 'md5' | 'sha1' | 'aes' | 'des'>;
  /**
   * indicates whether Authorization credentials are required for the request
   * @default true
   */
  withAuthorization?: boolean;
}

export interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
  /** only in axios interceptor config*/
  loading: boolean;
  showError: boolean;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  } else {
    throw new Error('please inject yourself instance like axios  ');
  }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
  const configs: IRequestConfig = {
    loading: serviceOptions.loading,
    showError: serviceOptions.showError,
    ...options,
    method,
    url
  };
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType
  };
  return configs;
}

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
  [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount?: number;
  items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
  totalCount?: number;
  items?: T[];
}

// customer definition
// empty

export class GisService {
  /**
   *
   */
  static getGisUpdate(
    params: {
      /** requestBody */
      body?: GisUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/gis/get-gis-update';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getImportResponses(
    params: {
      /** requestBody */
      body?: GetImportResponsesDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/gis/get-import-responses';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class ContractDatafileProcessService {
  /**
   *
   */
  static runContractDatafileProcess(
    params: {
      /** requestBody */
      body?: RunContractDatafileProcessDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/contract-datafile-process/run';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static continueContractDatafileProcess(
    params: {
      /**  */
      contractId: string;
      /**  */
      contractDatafileProcessId: string;
      /**  */
      templateId: string;
      /**  */
      executionId: string;
      /**  */
      sysUserId: string;
      /**  */
      requiredFiles: object;
      /** requestBody */
      body?: ContinueContractDatafileProcessDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/contract-datafile-process/continue';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = params.body;
      data = new FormData();
      if (params['contractId'] != null) {
        if (Object.prototype.toString.call(params['contractId']) === '[object Array]') {
          for (const item of params['contractId']) {
            data.append('contractId', item as any);
          }
        } else {
          data.append('contractId', params['contractId'] as any);
        }
      }

      if (params['contractDatafileProcessId'] != null) {
        if (Object.prototype.toString.call(params['contractDatafileProcessId']) === '[object Array]') {
          for (const item of params['contractDatafileProcessId']) {
            data.append('contractDatafileProcessId', item as any);
          }
        } else {
          data.append('contractDatafileProcessId', params['contractDatafileProcessId'] as any);
        }
      }

      if (params['templateId'] != null) {
        if (Object.prototype.toString.call(params['templateId']) === '[object Array]') {
          for (const item of params['templateId']) {
            data.append('templateId', item as any);
          }
        } else {
          data.append('templateId', params['templateId'] as any);
        }
      }

      if (params['executionId'] != null) {
        if (Object.prototype.toString.call(params['executionId']) === '[object Array]') {
          for (const item of params['executionId']) {
            data.append('executionId', item as any);
          }
        } else {
          data.append('executionId', params['executionId'] as any);
        }
      }

      if (params['sysUserId'] != null) {
        if (Object.prototype.toString.call(params['sysUserId']) === '[object Array]') {
          for (const item of params['sysUserId']) {
            data.append('sysUserId', item as any);
          }
        } else {
          data.append('sysUserId', params['sysUserId'] as any);
        }
      }

      if (params['requiredFiles'] != null) {
        if (Object.prototype.toString.call(params['requiredFiles']) === '[object Array]') {
          for (const item of params['requiredFiles']) {
            data.append('requiredFiles', item as any);
          }
        } else {
          data.append('requiredFiles', params['requiredFiles'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getContractDatafileProcessProgress(
    params: {
      /**  */
      executionId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/contract-datafile-process/progress';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { executionId: params['executionId'] };

      axios(configs, resolve, reject);
    });
  }
}

export interface GisUpdateDto {
  /**  */
  startDate?: number;

  /**  */
  endDate?: number;

  /**  */
  gisOrgId?: string;

  /**  */
  employeeId?: string;
}

export interface GetImportResponsesDto {
  /**  */
  gisDebtRequestId: string;
}

export interface RunContractDatafileProcessDto {
  /**  */
  contractId: string;

  /**  */
  contractDatafileProcessId: string;

  /**  */
  sysUserId?: string;
}

export interface ContinueContractDatafileProcessDto {
  /**  */
  contractId: string;

  /**  */
  contractDatafileProcessId: string;

  /**  */
  templateId: string;

  /**  */
  executionId?: string;

  /**  */
  sysUserId?: string;

  /**  */
  requiredFiles: object;
}
